import { render } from "./SectionsDashboardFacultyListItem.vue?vue&type=template&id=5daf7733&scoped=true"
import script from "./SectionsDashboardFacultyListItem.vue?vue&type=script&lang=js"
export * from "./SectionsDashboardFacultyListItem.vue?vue&type=script&lang=js"

import "./SectionsDashboardFacultyListItem.vue?vue&type=style&index=0&id=5daf7733&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5daf7733"]])

export default __exports__